// extracted by mini-css-extract-plugin
export default {"container":"wK-z","topReviewHeading":"xK-z","criticalReview":"yK-z","favorableReview":"zK-z","vsSeparator":"AK-z"};